<template>
    <section class="slice barometer-banner">
        <div class="barometer-banner__picto">
            <SvgPlanet />
        </div>
        <div class="slice-content">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <h2 class="slice-title barometer-banner__title" v-html="title" />
            <div class="slice-body barometer-banner__wrapper">
                <NuxtLink v-if="cta" :to="$withLocalePrefix(cta.url)">
                    <VJoyButton variant="primary">{{ cta.label }}</VJoyButton>
                </NuxtLink>
                <NuxtLink v-if="cta2" :to="$withLocalePrefix(cta2.url)">
                    <VJoyButton variant="ghost">{{ cta2.label }}</VJoyButton>
                </NuxtLink>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import SvgPlanet from '~/assets/svg/barometer/planet.svg?component';

    type Cta = {label: string; url: string};
    defineProps<{title: string; cta?: Cta; cta2?: Cta}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .barometer-banner {
        margin-top: var(--joy-core-spacing-10);
        background-color: var(--joy-color-primary-50);

        &__title {
            margin-top: var(--joy-core-spacing-6);
            color: var(--joy-color-neutral-0);
        }
        &__wrapper {
            display: inline-flex;
            justify-content: center;
            flex-wrap: wrap;

            > a {
                display: block;
                margin: var(--joy-core-spacing-2);
                width: 100%;
                max-width: 350px;

                @include mq.screen_sm(min) {
                    width: auto;
                }
            }
            button {
                width: 100%;
            }
        }
        &__picto {
            position: absolute;
            background-color: var(--joy-color-neutral-0);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: var(--joy-core-radius-6);
            transform: translate3d(-50%, -50%, 0);
            aspect-ratio: 1 / 1;
            width: 100px;
            top: 0;
            left: 50%;

            > svg {
                width: 90px;
                height: 60px;
            }

            @include mq.screen_sm(min) {
                width: 110px;
                > img {
                    width: 87px;
                }
            }
        }
    }
</style>
